import PropTypes from "prop-types";
import { Router } from "react-router-dom";

export const LOCATION_CHANGE = "@@router/LOCATION_CHANGE";
export const CALL_HISTORY_METHOD = "@@router/CALL_HISTORY_METHOD";

const normalizeLocationPart = value => value || "";

export const hasLocationChanged = (currentLocation = {}, nextLocation = {}) =>
  normalizeLocationPart(currentLocation.pathname) !==
    normalizeLocationPart(nextLocation.pathname) ||
  normalizeLocationPart(currentLocation.search) !==
    normalizeLocationPart(nextLocation.search) ||
  normalizeLocationPart(currentLocation.hash) !==
    normalizeLocationPart(nextLocation.hash);
const getRouterState = (location, action = "POP") => ({
  location,
  action,
  locationBeforeTransitions: location
});

export const connectRouter = history => {
  const initialState = getRouterState(history.location, history.action);

  return (state = initialState, action) => {
    if (action.type !== LOCATION_CHANGE) {
      return state;
    }

    return getRouterState(action.payload.location, action.payload.action);
  };
};

export const routerMiddleware = history => store => {
  history.listen((location, action) => {
    store.dispatch({
      type: LOCATION_CHANGE,
      payload: { location, action }
    });
  });

  return next => action => {
    if (action.type === CALL_HISTORY_METHOD) {
      const { method, args = [] } = action.payload || {};
      const [nextLocation] = args;
      const shouldSkipReplace =
        method === "replace" &&
        nextLocation &&
        typeof nextLocation === "object" &&
        !hasLocationChanged(history.location, nextLocation);

      if (typeof history[method] === "function" && !shouldSkipReplace) {
        history[method](...args);
      }

      return action;
    }

    return next(action);
  };
};

export const replace = (...args) => ({
  type: CALL_HISTORY_METHOD,
  payload: {
    method: "replace",
    args
  }
});

export const ConnectedRouter = ({ history, children }) => (
  <Router history={history}>{children}</Router>
);

ConnectedRouter.propTypes = {
  history: PropTypes.shape({
    listen: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    action: PropTypes.string.isRequired
  }).isRequired,
  children: PropTypes.node.isRequired
};
